/* eslint-disable react/jsx-props-no-spreading */
import React, { useState } from 'react';
import {
  Autocomplete, CircularProgress, TextField, Box,
} from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import { useDebounce } from 'use-debounce';
import useMerchantSearch from '../../resources/merchant/search';

const RepairFinderAutocomplete = ({ map, setSelectedDealershipId }) => {
  const [query, setQuery] = useState('');
  const [debouncedQuery] = useDebounce(query, 500);
  const {
    isLoading,
    data: [queriedDealerships = { suggestions: [] }] = [],
  } = useMerchantSearch({
    query: debouncedQuery,
    lat: map.getCenter().lat(),
    lng: map.getCenter().lng(),
  });

  const handleAutocompleteSelect = (e, selectedOption) => {
    if (!selectedOption) {
      setQuery('');
      setSelectedDealershipId(null);
      return;
    }

    map.panTo({
      lat: parseFloat(selectedOption.position.lat),
      lng: parseFloat(selectedOption.position.lng),
    });
    setSelectedDealershipId(selectedOption.id);
  };

  const startAdornment = (
    <Box sx={{
      width: '24px', display: 'flex', justifyContent: 'center', alignItems: 'center',
    }}
    >
      { isLoading ? <CircularProgress size={16} /> : <SearchIcon color="info" />}
    </Box>
  );

  const noResultsFound = debouncedQuery !== '' && !isLoading;

  return (
    <Autocomplete
      noOptionsText={noResultsFound ? 'No dealerships found' : 'Type to find a dealership'}
      forcePopupIcon={false}
      id="dealership-suggestions"
      onChange={handleAutocompleteSelect}
      options={queriedDealerships.suggestions}
      getOptionLabel={(option) => option.name}
      renderInput={(params) => (
        <TextField
          {...params}
          fullWidth
          label="Dealership Name"
          InputProps={{
            ...params.InputProps,
            startAdornment,
            sx: {
              '.MuiAutocomplete-input': {
                backgroundColor: 'inherit',
              },
            },
          }}
          value={query}
          onChange={(e) => setQuery(e.target.value)}
        />
      )}
    />
  );
};

export default RepairFinderAutocomplete;
